import keyMirror from '../services/key_mirror';

export default keyMirror([
  'CLEAN',
  'CHALLENGE',
  'POST',
  'COMPLETE',
], 'readingModes');
